export default "__VITE_ASSET__DXo5Ulsx__"